import { z } from "zod";
/** Upper bound for console SQL, whether typed, saved or handed over in a link. */
export const QUERY_LENGTH_LIMIT = 50_000;
export const queryInput = z.object({
  name: z.string().trim().min(1),
  query: z
    .string()
    .min(1)
    .max(QUERY_LENGTH_LIMIT)
    .refine((value) => !!value.trim()),
});
export type SavedQuery = {
  id: string;
  name: string;
  query: string;
  revision: number;
};
export type SavedQuerySummary = Pick<SavedQuery, "id" | "name" | "revision">;

/** Use only a table and columns selected from the Console catalog. */
export function tableQuery(table: string, columns: string[]) {
  const quote = (value: string) => `"${value.replaceAll('"', '""')}"`;
  return `SELECT ${columns.map(quote).join(", ")}
FROM ${table.split(".").map(quote).join(".")}
LIMIT 100`;
}

/** Existing HTTP save contract, shared with MCP writes. */
export const savedQueryInputSchema = z.object({
  name: z.string().trim().min(1).max(120),
  query: z.string().trim().min(1).max(20_000),
});
